var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('ImportCSV',{attrs:{"enabled":"","name":"importCV"},on:{"fileUploaded":_vm.formatData,"fileUploadedError":function($event){return _vm.fileError()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }